/**
 * Медиавыражения для определения соответствия документа определенному разрешению
 *
 * @name data.EMediaWidth
 * @type {enum}
 */
export enum EMediaWidth {
    sDesktop = '(max-width: 1365px)',
    sDesktopMin = '(min-width: 1366px)',
    sDesktopOnly = '(max-width: 1365px) and (min-width: 1023px)',
    tablet = '(max-width: 1023px)',
    tabletOnly = '(max-width: 1023px) and (min-width: 768px)',
    mobile = '(max-width: 767px)',
}
